import theme from '@styles/theme';
export default {
  container: {
    position: 'relative',
    width: '100%',
    height: '100%',
    '.swiper ': {
      height: '100%'
    },
    '.swiper-pagination': {
      display: 'flex',
      width: '100%',
      height: 4,
      position: 'absolute',
      bottom: 0,
      flexDirection: 'row',
      justifyContent: 'center',
      p: ['0 16px', '0 16px', '0 24px', '0 24px', '0 24px', '0 40px'],
      span: {
        display: 'inline-block',
        minWidth: 10,
        heigth: 4,
        backgroundColor: 'transparent',
        borderBottom: `2px solid ${theme.rawColors.lightGrey700}`,
        flexGrow: 1,
        m: '0 4px',
        borderRadius: 'unset',
        cursor: 'pointer'
      },
      '.swiper-pagination-bullet-active': {
        backgroundColor: theme.rawColors.darkGrey700,
        borderBottom: 0,
        borderRadius: 'unset'
      }
    },
    '.swiper-wrapper': {
      height: 'calc( 100% - 20px)',
      backgroundColor: theme.rawColors.darkGrey700
    },
    '.swiper-slide': {
      width: '100%',
      backgroundColor: theme.rawColors.darkGrey700
    },
    img: {
      objectFit: 'cover'
    }
  }
};